import { LoadingOutlined } from "@ant-design/icons";
import { Col, Empty, Row, Spin } from "antd";
import CardDraftSegment from "component/cards/draft/card_draft_segment";
import React from "react";
import { useSelector } from "react-redux";
import { refineDataForVisualize } from "store/bailiff/draft/dialog/draft_dialog.action";
import { draftDialogDetailSelector } from "store/bailiff/draft/dialog/draft_dialog.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const SegmentLists = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const data = useSelector(draftDialogDetailSelector);
  const visualize = refineDataForVisualize(data);
  console.log({ visualize });

  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderLists = () => {
    return (
      <Row style={{ marginTop: 20 }} gutter={[0, 20]} justify={"start"}>
        {visualize?.map((item, index) => (
          <Col align="left" key={index} xl={24} lg={24} md={24} xs={24}>
            <CardDraftSegment data={item} />
          </Col>
        ))}
      </Row>
    );
  };

  const renderEmpty = () => {
    if (visualize?.length === 0) {
      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: 300,
          }}
        >
          <Empty description="Không có đoạn hội thoại nào" />
        </div>
      );
    }
  };

  const renderLoading = () => {
    if (visualize === null) {
      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: 300,
            flexDirection: "column",
            gap: 10,
          }}
        >
          <Spin indicator={<LoadingOutlined spin />} />
          <span style={{ color: "#aeaeae" }}>Đang tải đoạn hội thoại..</span>
        </div>
      );
    }
  };

  // -------------------------- MAIN ----------------------------
  return (
    <>
      {renderLists()}
      {renderEmpty()}
      {renderLoading()}
    </>
  );
};
export default SegmentLists;
